import { useToast } from '@winnin/winnin_ui.components.toast'

import { useTranslate } from 'lib/tolgee'
import { TOLGEE_GLOBALS } from 'utils'

export default function useCopyToClipboard() {
  const { createToast } = useToast()
  const t = useTranslate()

  const defaultSuccess = t(TOLGEE_GLOBALS.clipboardSuccess)
  const defaultError = t(TOLGEE_GLOBALS.defaultError)

  function copyToClipboard({ textToCopy, successText = defaultSuccess, errorText = defaultError }) {
    navigator.clipboard
      .writeText(textToCopy)
      .then(() => {
        createToast({
          content: successText,
        })
      })
      .catch(error => {
        console.error('useCopyToClipboard @ copyToClipboard >>>>>', error)

        createToast({
          content: errorText,
        })
      })
  }

  return { copyToClipboard }
}
